import { render, staticRenderFns } from "./gift-list.vue?vue&type=template&id=01520e58&scoped=true"
import script from "./gift-list.vue?vue&type=script&lang=js"
export * from "./gift-list.vue?vue&type=script&lang=js"
import style0 from "./gift-list.vue?vue&type=style&index=0&id=01520e58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01520e58",
  null
  
)

export default component.exports